export enum Roles {
  ADMIN = 'ADMIN',
  CREATOR = 'CREATOR',
  EXECUTOR = 'EXECUTOR',
  VOTER = 'VOTER',
}

export enum Actions {
  CREATE_PROJECT = 'CREATE_PROJECT',
  VIEW_LIST = 'VIEW_LIST',
  UPDATE = 'UPDATE',
  PUBLISH = 'PUBLISH',
  REQUEST = 'REQUEST',
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  RELEASE = 'RELEASE',
}

export const FULL_PERMISSIONS: Actions[] = [
  Actions.CREATE_PROJECT,
  Actions.VIEW_LIST,
  Actions.PUBLISH,
  Actions.UPDATE,
  Actions.APPROVE,
  Actions.REJECT,
  Actions.RELEASE,
  Actions.REQUEST,
];

// Map roles to actions
export const RolePermissions: Record<Roles, Actions[]> = {
  [Roles.ADMIN]: FULL_PERMISSIONS,
  [Roles.CREATOR]: FULL_PERMISSIONS,
  [Roles.VOTER]: FULL_PERMISSIONS,
  [Roles.EXECUTOR]: FULL_PERMISSIONS,
};
